import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Toggle } from "material-ui"
import strings from "../../../localization/strings"
import { IDate, IPayrollPayGroupData } from "../../../models"
import DateRangeSelect from "../../../components/common/DateRangeSelect"
import * as reportAction from "../../../actions/ReportAction"
import AccountStore from "../../../stores/AccountStore"
import moment from "moment"
import * as timecardHelper from "../../../helpers/timecardHelper"

interface IProps {
    userId: string
    payrollPayGroupData: IPayrollPayGroupData
    referenceDate: IDate
    handleClose(): void
}
interface IState {
    includePunchPhoto: boolean
    startDate: IDate
    endDate: IDate
    isValid: boolean
}

export default class EmployeeTimecardDefaultReport extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const timecardDates = timecardHelper.getTimecardDateByPayrollPayGroupData(props.referenceDate, props.payrollPayGroupData)
        this.state = {
            includePunchPhoto: false,
            startDate: moment(timecardDates.StartDate).utc(true).format(),
            endDate: moment(timecardDates.EndDate).utc(true).format(),
            isValid: true,
        }
        autobind(this)
    }

    handleDownload() {
        this.props.handleClose()
        reportAction.downloadEmployeeTimecardReport(
            AccountStore.getCurrentAccount().Id,
            this.props.userId,
            this.state.startDate as string,
            this.state.endDate as string,
            moment().utc(true).format(),
            this.state.includePunchPhoto
        )
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Employee_Timecard_Report}
                actions={[
                    <FlatButton data-intercom-target={"Employee-Timecards-Reports-Btn-Close-Dialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"Employee-Timecards-Reports-Btn-Download-Report"} key="download" label={strings.Download} disabled={!this.state.isValid} primary onTouchTap={this.handleDownload} />
                ]}
            >
                <DateRangeSelect
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    handleChange={(startDate, endDate, isValid) => this.setState({ startDate, endDate, isValid })}
                    sameDatesAllowed
                />
                <Toggle
                    toggled={this.state.includePunchPhoto}
                    onToggle={(e, includePunchPhoto) => this.setState({ includePunchPhoto })}
                    label={strings.Include_Punch_Photo}
                    style={{ paddingTop: 10, width: 275 }}
                />
            </Dialog>
        )
    }
}